import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';

export const PublishedAssignment = (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
  store.dispatch('publishedAssignment/getAssignmentToView', Number(to.params.entregaId));
  next();
};
